import React from "react";

// Official COMMITMENTT brand lockup — icon-only mark (cropped from the official artwork,
// never redrawn) with the COMMITMENTT name beside it.
export function Logo({ size = 36, showText = true, dark = false, textClass = "" }) {
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="brand-logo">
      <img src="/logo-mark.png" alt="COMMITMENTT" width={size} height={size}
           style={{ width: size, height: size, objectFit: "contain" }} className="rounded-lg" />
      {showText && (
        <span className={`font-heading font-bold tracking-tight ${dark ? "text-white" : "text-ink"} ${textClass}`}>
          COMMITMEN<span className="text-mint">TT</span>
        </span>
      )}
    </div>
  );
}
